import { MaintenancePage } from '@shared/components';
import { useFrontendMaintenanceMode } from '@shared/hooks';
import { ReactElement, ReactNode } from 'react';

type MaintenanceGateProps = {
  children: ReactNode;
  isPlugin?: boolean;
};

export function MaintenanceGate({
  children,
  isPlugin = false,
}: MaintenanceGateProps): ReactElement {
  const { enabled, loading, error } = useFrontendMaintenanceMode();

  if (loading) {
    return <>{children}</>;
  }

  if (error) {
    return <>{children}</>;
  }

  if (enabled) {
    return <MaintenancePage isPlugin={isPlugin} />;
  }

  return <>{children}</>;
}
